import { CheckoutEnvironment } from './checkout-drop-in-api';

export const sanitizeEnvironment: (environment: any) => CheckoutEnvironment = (environment: any) => {
  // Map enviroment to uppercase for backward compatibility
  if (typeof environment === 'string') {
    environment = environment.toUpperCase();
  }

  if (environment !== undefined && environment !== null && environment !== 'LIVE' && environment !== 'PREVIEW') {
    throw new Error(`Environment ${JSON.stringify(environment)} not supported.`);
  }
  return environment ?? 'LIVE';
};

export const sanitizeProductId: (productId: any, errorMessage?: string) => string = (productId: any, errorMessage: string = 'ProductId is missing.') => {
  return sanitizeId(productId, errorMessage);
};

export const sanitizeVendorId: (vendorId: any, errorMessage?: string) => string = (vendorId: any, errorMessage: string = 'VendorId is missing.') => {
  return sanitizeId(vendorId, errorMessage);
};

const sanitizeId: (id: any, errorMessage: string) => string = (id: any, errorMessage: string) => {
  if (id === undefined || id === null || typeof id !== 'string' || id.length === 0) {
    throw new Error(errorMessage);
  }
  return id;
};
